import React from 'react'
import { Path, SVG } from '@wordpress/components'

const KeyboardEvent = window.KeyboardEvent

const ModalNavigation = () => {
  return (
    <div className='popup-navigation'>
      <button
        id='popup_navigation_left'
        className='popup-nav-button navigation--arrow-left'
        title='Previous'
        onClick={() => document.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowLeft' }))}
      >
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <SVG xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
          <Path d='M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z'/>
        </SVG>
      </button>
      <button
        id='popup_navigation_right'
        className='popup-nav-button navigation--arrow-right'
        title='Next'
        onClick={() => {
          document.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowRight' }))
        }}
      >
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <SVG xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
          <Path d='M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z'/>
        </SVG>
      </button>
    </div>
  )
}

export default ModalNavigation
